import gql from 'graphql-tag';

const QUERY_MATCHER = gql`
  query Matcher(
    $cityId: String!
    $filters: FiltersInput
    $locale: String
    $limit: Int
  ) {
    search(cityId: $cityId, filters: $filters, limit: $limit) {
      totalMarkers
      homecards(locale: $locale) {
        adId
        aptFeatures
        checked
        currencyIsoCode
        cancellationPolicy
        features
        firstAvailableDate
        id
        isInstantBooking
        noSecurityDeposit
        isFavorite
        isNew
        isSuperlister
        isSelect
        mainPhotoUrl
        monthlyPrice {
          fixedPrice
          minimumPrice
          pricesByMonth {
            jan
            feb
            mar
            apr
            may
            jun
            jul
            aug
            sep
            oct
            nov
            dec
          }
          type
        }
        photoUrls {
          homecardHidpi
          homecard
        }
        reviews {
          ratingAverage
        }
        title
        type
        url
      }
    }
  }
`;

export const getMatcherQuery = client => (
  cityId,
  filters,
  locale = 'en',
  limit
) =>
  client.query({
    errorPolicy: 'all',
    query: QUERY_MATCHER,
    variables: {
      cityId,
      filters,
      locale,
      limit
    }
  });

export default getMatcherQuery;
